import { render } from "./registration-clinic-created.vue?vue&type=template&id=45836e14&scoped=true"
import script from "./registration-clinic-created.vue?vue&type=script&lang=js"
export * from "./registration-clinic-created.vue?vue&type=script&lang=js"

import "./registration-clinic-created.vue?vue&type=style&index=0&id=45836e14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45836e14"]])

export default __exports__